import type { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../../lib/helpers';

interface LogModalRowProps {
  /**
   * Row label
   */
  label: ReactNode;
  /**
   * Row value
   */
  value: ReactNode;
  /**
   * Has column direction
   */
  colDirection?: boolean;
  /**
   * Test id
   */
  testId?: string;
}

const LogModalRow = ({
  label,
  value,
  colDirection,
  testId,
}: LogModalRowProps) => (
  <div
    className={twMerge(
      'flex mb-2 w-full',
      colDirection ? 'flex-col' : 'flex-row',
    )}
    {...getTestProps(testId, `container`)}
  >
    <label className="text-base font-bold mr-2">{label}</label>
    <label className="text-base font-normal">{value}</label>
  </div>
);

export default LogModalRow;
